"use client";

import {
  formatMoney as newFormatMoney,
  IFormatMoneyProps,
} from "@faire/web/common/money";
import * as React from "react";

export const Money: React.FunctionComponent<IFormatMoneyProps> = (props) => (
  <>{newFormatMoney(props)}</>
);

export namespace Money {
  export type IProps = IFormatMoneyProps;
}
